export default __webpack_public_path__ + "static/media/main3(4).0fc06129.png";